<template>
    <div class="competition_wrap">
        <div class="competition_item mypage_filter_item">
            <div class="competition_input">
                <el-input :placeholder="$t('st')" v-model="searchInput"
                          @keypress.native.enter="setFilterFunc(searchInputOption,searchInput)">
                </el-input>
                <button class="competition_btn" @click="setFilterFunc(searchInputOption,searchInput)"></button>
            </div>
        </div>
        <div class="competition_btn_wrap">
            <button class="c_filter_btn" @click="openFilter('competition-filter-judge-filter')"></button>
            <!--목록형 아이콘-->
            <button class="c_filter_list_btn"
                    v-show=" listChange === 'list'"
                    @click="listTypeChange('thumbnail')"></button>
            <!--썸네일형 아이콘      -->
            <button class="c_filter_thumnail_btn"
                    v-show=" listChange === 'thumbnail'"
                    @click="listTypeChange('list')"></button>
        </div>
        <div class="clear"></div>
        <competition-filter-judge-filter></competition-filter-judge-filter>
    </div>
<!--    <div class="search_item mb19">
        <div class="filter_category_box mr5">
            <el-select id="category" v-model="searchInputOption" class="my_filter select"
                       popper-class="select_style"
                       :popper-append-to-body="false">
                <el-option :value="'ti'" :label="$t('subject')"></el-option>
                <el-option :value="'hash'" :label="$t('hashtag')"></el-option>
                <el-option :value="'ni'" :label="$t('organizer')"></el-option>
            </el-select>
        </div>
        <div class="search_input mypage_search_input">
            <el-input :placeholder="$t('st')" v-model="searchInput"
                      @input="setData('searchInput',searchInput)"
                      @keypress.enter.native="setFilterFunc(searchInputOption,searchInput)"/>
            <button class="search_btn mypage_search_btn" @click="setFilterFunc(searchInputOption,searchInput)">
            </button>
        </div>
        <button class="search_filter_btn" @click="openFilter('competition-filter-judge-filter')"></button>
        <competition-filter-judge-filter></competition-filter-judge-filter>
    </div>-->
</template>

<script>
import util from "@/mixins/util";
import competitionUtil from "@/components/competition/competitionUtil";
import CompetitionFilterJudgeFilter from "@/components/filter/CompetitionFilterJudgeFilter";
import EventBus from "@/utils/event-bus";

const {filterConfig} = competitionUtil

export default {
    name: "CompetitionFilterJudgeLayout",
    mixins: [],
    components: {CompetitionFilterJudgeFilter},
    inject: ['setFilter'],
    provide() {
        return {}
    },
    props: {
        filterData: {
            default: () => {
            }
        },
    },
    data() {
        return {
            listChange: 'list',
            searchInputOption: 'ti',
            searchInput: '',
            filterStatus: [],
            filterCategory: [],
            filterDate: [],
            filterPrice: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.setterFilterDataInData();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        openFilter(name) {
            this.$modal.show(name, {filterData: this.filterData});
        },
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    // this[classname] =
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
        },
        listTypeChange(type) {
            this.listChange = type;
            EventBus.$emit('changeListType', type);
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        setData(key, value) {
            this[key] = value;
        },
        openModal(name) {
            this.$modal.show(name);
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
